import { render, staticRenderFns } from "./UpdatePhoneBox.vue?vue&type=template&id=51bb7540&scoped=true"
import script from "./UpdatePhoneBox.vue?vue&type=script&lang=js"
export * from "./UpdatePhoneBox.vue?vue&type=script&lang=js"
import style0 from "./UpdatePhoneBox.vue?vue&type=style&index=0&id=51bb7540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb7540",
  null
  
)

export default component.exports